// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PartnerScoreHelper from "../../domain/helper/PartnerScoreHelper.bs.js";

function getMessageBoxContent(name, action_state) {
  var match = PartnerScoreHelper.stringToScoreTypeEnum(name);
  switch (match) {
    case /* COMPLETION_SCORE */0 :
        return {
                message_box_text_color: "#000000",
                message_box_color: "#f4f5f6",
                message_box_icon_path: "stars.svg"
              };
    case /* CANCELLATION_SCORE */1 :
        switch (action_state) {
          case "APPLIED" :
              return {
                      message_box_text_color: "#FCFCFC",
                      message_box_color: "#DB230A",
                      message_box_icon_path: "danger.svg"
                    };
          case "SAFE" :
              return {
                      message_box_text_color: "#2D2F34",
                      message_box_color: "#E3FCF4",
                      message_box_icon_path: "thumbs-up.svg"
                    };
          case "WARN" :
              return {
                      message_box_text_color: "#2D2F34",
                      message_box_color: "#FEC",
                      message_box_icon_path: "warning.svg"
                    };
          default:
            return {
                    message_box_text_color: "",
                    message_box_color: "",
                    message_box_icon_path: ""
                  };
        }
    case /* DEFAULT */2 :
        return {
                message_box_text_color: "",
                message_box_color: "",
                message_box_icon_path: ""
              };
    
  }
}

function checkActiveSuspension(action_state) {
  if (action_state === "APPLIED") {
    return true;
  } else {
    return false;
  }
}

function getThresholds(thresholds) {
  return Belt_List.map(thresholds, (function (val) {
                return String(val) + "%";
              }));
}

function getTrackThresholds(thresholds, name) {
  var match = PartnerScoreHelper.stringToScoreTypeEnum(name);
  switch (match) {
    case /* CANCELLATION_SCORE */1 :
        return Belt_List.map(Belt_List.add(thresholds, 0), (function (val) {
                      return String(val) + "%";
                    }));
    case /* COMPLETION_SCORE */0 :
    case /* DEFAULT */2 :
        return /* [] */0;
    
  }
}

function getMaxThresholdValue(thresholds, name) {
  var match = PartnerScoreHelper.stringToScoreTypeEnum(name);
  switch (match) {
    case /* CANCELLATION_SCORE */1 :
        return Belt_Option.getWithDefault(Belt_List.head(Belt_List.reverse(thresholds)), 0);
    case /* COMPLETION_SCORE */0 :
    case /* DEFAULT */2 :
        return 100;
    
  }
}

function getActionThreshold(name, action_threshold, thresholds, value) {
  var match = PartnerScoreHelper.stringToScoreTypeEnum(name);
  var action_threshold_mod;
  switch (match) {
    case /* COMPLETION_SCORE */0 :
        action_threshold_mod = 0;
        break;
    case /* CANCELLATION_SCORE */1 :
        action_threshold_mod = action_threshold !== 0 ? action_threshold : Belt_Option.getWithDefault(Belt_List.getBy(thresholds, (function (x) {
                      return x === (value | 0);
                    })), Belt_Option.getWithDefault(Belt_List.getBy(Belt_List.reverse(thresholds), (function (x) {
                          return x < (value | 0);
                        })), 0));
        break;
    case /* DEFAULT */2 :
        action_threshold_mod = 0;
        break;
    
  }
  return String(action_threshold_mod) + "%";
}

function getActionDetails(score) {
  return {
          active_suspension: checkActiveSuspension(score.action_details.action_state),
          action_threshold: getActionThreshold(score.name, score.action_details.action_threshold, score.thresholds, score.value),
          action_text: score.action_details.action_text
        };
}

function getVm(res) {
  return List.map((function (score) {
                return {
                        name: score.name,
                        value: score.value,
                        min_score: 0,
                        max_score: getMaxThresholdValue(score.thresholds, score.name),
                        locked_state: score.locked_state,
                        thresholds: getThresholds(score.thresholds),
                        action_value: score.action_value,
                        action_details: getActionDetails(score),
                        message_box: getMessageBoxContent(score.name, score.action_details.action_state),
                        track_thresholds: getTrackThresholds(score.thresholds, score.name)
                      };
              }), res);
}

export {
  getMessageBoxContent ,
  checkActiveSuspension ,
  getThresholds ,
  getTrackThresholds ,
  getMaxThresholdValue ,
  getActionThreshold ,
  getActionDetails ,
  getVm ,
  
}
/* PartnerScoreHelper Not a pure module */
